/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const dateFormat = {
  monthYear: "MMMM YYYY",
  monthYearShort: "MMM, YYYY",
  monthYearShortNoComma: "MMM YYYY",
  dayMonthYearShortNoComma: "D MMM YYYY",
  awsDateTime: "YYYY-MM-DDThh:mm:ssZ",
  fullDate: "DD MMMM YYYY, HH:mm:ss",
  fullDateShort: "D MMM YYYY HH:mm:ss",
  fullDateDash: "YYYY-MM-DDTHH:mm:ssZ",
  hour: "HH:mm:ss",
  hourMinute: "HH:mm",
  dayMonth: "DD MMMM",
  dayMonthShort: "DD MMM",
  monthDayShort: "MMM, DD",
  day: "DD",
  dayShort: "D",
  dayMonthYear: "DD MMMM YYYY",
  dayShortMonthYear: "DD MMM YYYY",
  monthShort: "MMM",
  monthName: "MMMM",
  shortDate: "YYYY-MM-DD",
  shortDateWithTime: "YYYY-MM-DD HH:mm",
  shortDateWithTimezone: "YYYY-MM-DDz",
  year: "YYYY",
} as const;
